import { getAllActions } from "../generic/all.actions";
import CONFIG from "./employeeAccount.config";
export var getPaged = getAllActions({
    entityName: CONFIG.ENTITY_NAME,
}).getPaged;
